import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button"]

    handleClick(event) {
        const button = event.currentTarget;
        const target = document.querySelector(button.dataset.modalTarget);
        const wrapper = target?.closest(".accordion-section-wrapper");

        if (target && wrapper) {
            const targetLink = wrapper.querySelector(".section-link");

            if (targetLink?.classList.contains("collapsed")) {
                targetLink.click();
            }

            const currentField = target.closest(".field");
            if (!currentField) return;

            if (button.dataset.scrollOn === "true") {
                setTimeout(() => {
                    currentField.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 400);
            }
        }
    }
}
